import { z } from 'zod';

export const gaPageEntrySchema = z.object({
  path: z.string(),
  sessions: z.number().int().nonnegative(),
});
export type GaPageEntry = z.infer<typeof gaPageEntrySchema>;

export const gaTrafficSourceEntrySchema = z.object({
  source: z.string(),
  sessions: z.number().int().nonnegative(),
});
export type GaTrafficSourceEntry = z.infer<typeof gaTrafficSourceEntrySchema>;

export const analyticsSnapshotSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  periodStart: z.string().datetime(),
  periodEnd: z.string().datetime(),
  sessions: z.number().int().nonnegative(),
  users: z.number().int().nonnegative(),
  pageViews: z.number().int().nonnegative(),
  bounceRate: z.number().min(0).max(1),
  topPages: z.array(gaPageEntrySchema),
  trafficSources: z.array(gaTrafficSourceEntrySchema),
  pulledAt: z.string().datetime(),
});
export type AnalyticsSnapshotSummary = z.infer<typeof analyticsSnapshotSchema>;
